export const SIDEBAR_POPUP_CONTAINER = 'js-sidebar-popup-container';
export const SIDEBAR_POPUP_ITEM = 'js-sidebar-popup-item';
export const SIDE_MENU_CONTAINER = '.side-menu-standard-container';
export const SIDEBAR_POPUP_CTA_BUTTON = 'js-sidebar-popup-cta-button';
export const SIDE_MENU_TABS = 'js-side-menu-tabs';
export const SIDE_MENU_TABS_BUTTON = 'js-side-menu-tabs-button';
export const SIDE_MENU_TABS_CONTENT = 'js-side-menu-tabs-content';
export const SIDE_MENU = 'js-side-menu';

export const ACTIVE_SIDE_BAR = 'side-menu__container--active';
